import { App } from './app.services';

const SessionCore = (state) => {
  return App(state);
}

export {
  SessionCore
}
